import { type ImageLoaderProps } from "next/image";

/**
 * An incoming image should take the form of:
 * https://platform.staging.vox.com/wp-content/uploads/sites/2/2024/02/popecoat_final-edited-1.jpg?crop=0,0,100,100
 * and output (at a requested width of 640) the following URL:
 * https://platform.staging.vox.com/wp-content/uploads/sites/2/2024/02/popecoat_final-edited-1.jpg?crop=0,0,100,100&w=640
 */
function wpLoader({ src, width }: ImageLoaderProps): string {
  const url = new URL(src);
  url.searchParams.set("w", width.toString());
  return url.toString();
}

/**
 * This loader is used by the `Image` component so should be used for all images across Duet.
 */
export function defaultLoader({ src, width }: ImageLoaderProps): string {
  try {
    const url = new URL(src);

    const pathParts = url.pathname.split("/");

    if (pathParts[1] === "wp-content") {
      return wpLoader({ src, width });
    }
    return src;
  } catch {
    // If the URL is invalid (e.g. doesn't include a domain), return the original URL
    return src;
  }
}

export const placeholderData =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8+R8AAtcB6oaHtZcAAAAASUVORK5CYII=";
